<template>
  <div class="page-content">
    <AppNavbar
      v-if="!isWx"
      :placeholder="true"
      :options="options"
      :zIndex="20"
      :title="options.title"
    >
      <div slot="right">
        <span
          class="calendar iconfont icon-xunlianrili"
          @click="bindCalebdar"
        ></span>
      </div>
    </AppNavbar>
    <div class="container" v-if="dietData">
      <div class="c-top">
        <!-- 用户信息 -->
        <div class="user-info c-padding">
          <img
            class="avatar"
            :src="dietData.u_img"
            alt=""
            @click="bindIntoUserInfo"
          />
          <div class="user-right">
            <p class="name"
              ><span class="truename">{{
                dietData.remark_name || dietData.u_name
              }}</span></p
            >
            <p class="camp"
              ><span class="nickname" v-if="dietData.nickname"
                >({{ dietData.nickname }})</span
              >
              {{ dietData.alias }}</p
            >
          </div>
          <div
            v-if="isWx"
            class="user-calendar iconfont icon-xunlianrili"
            @click="bindCalebdar"
          ></div>
        </div>
        <!-- 标签列表 -->
        <div class="tag-container c-padding" v-if="sevenTagData.list.length">
          <div class="tag-list" :class="{ maxheight: !sevenTagData.openTag }">
            <div
              class="tag-item"
              v-for="(item, index) in sevenTagData.list"
              :key="index"
            >
              <span :class="['tag-color-' + item.type]">{{
                item.label_name
              }}</span
              ><span class="tag-num">{{ item.label_num }}次</span>
            </div>
          </div>
          <div
            class="open-tag"
            @click="bindOpenTag(sevenTagData)"
            v-if="sevenTagData.list.length > 5"
          >
            <span>{{ sevenTagData.openTag ? '收起' : '展开更多' }}</span
            ><span class="iconfont icon-black"></span>
          </div>
        </div>
        <!-- 用户标签 -->
        <div class="tag-container c-padding" v-if="userTagData.list.length">
          <div class="tag-list" :class="{ maxheight: !userTagData.openTag }">
            <div
              class="tag-item"
              :class="['user-tag-' + item.attr]"
              v-for="(item, index) in userTagData.list"
              :key="index"
            >
              <span>{{ item.tag_name }}</span>
            </div>
          </div>
          <div
            class="open-tag"
            @click="bindOpenTag(userTagData)"
            v-if="userTagData.list.length > 5"
          >
            <span>{{ userTagData.openTag ? '收起' : '展开更多' }}</span
            ><span class="iconfont icon-black"></span>
          </div>
        </div>
        <!-- 餐卡信息 -->
        <div class="diet-image-container">
          <div class="d-list">
            <img
              class="d-item"
              v-for="(item, index) in dietData.content"
              :key="index"
              :src="
                formatImageUrl(
                  item + '?x-oss-process=image/resize,w_300/quality,Q_80'
                )
              "
              alt=""
              @click="previewImage(dietData.content, index)"
            />
          </div>
        </div>
        <div class="diet-info c-padding">
          <div class="diet-title" v-if="dietData.title">
            {{ dietData.title }}
          </div>
          <div class="diet-desc">
            {{ dietData.say }}
          </div>
          <div class="ai-desc" v-if="dietData.ai_data && dietData.ai_data.food">
            <div class="ai-title">AI食材记录</div>
            <div
              ><span v-for="(item, index) in dietData.ai_data.food" :key="index"
                >{{ item.p }}{{ item.pu }}{{ item.n
                }}{{
                  index < dietData.ai_data.food.length - 1 ? '、' : ''
                }}</span
              >
            </div>
          </div>
          <div class="status-tag-list" v-if="dietData.enum_list">
            <div
              class="status-tag-item"
              v-for="(item, index) in dietData.enum_list"
              :key="index"
              >{{ item.name }}</div
            >
            <div
              class="status-tag-item status-tag-icon-item"
              v-if="dietData.satiety_num_icon"
              ><img
                class="status-tag-icon"
                :src="dietData.satiety_num_icon"
                alt=""
            /></div>
          </div>
          <div class="diet-time">{{ dietData.addtime | filterTime }}</div>
        </div>
        <!-- 饱饱餐 -->
        <div class="bbc-container" v-if="bbcData && bbcData.is_baobao_class">
          <div class="bbc-title">近三餐有无饱饱碗</div>
          <div class="bbc-list">
            <div class="bbc-item" v-for="(item, index) in bbcList" :key="index"
              >· {{ item }}</div
            >
          </div>
        </div>
      </div>
      <div class="space"></div>
      <div class="c-center">
        <van-tabs v-model="curNav" @click="bindChangeTitle">
          <van-tab
            :title="item.name"
            v-for="(item, index) in navList"
            :key="index"
          >
            <div class="tab-container">
              <AssociationFood
                v-show="index == 0"
                :data="associationData"
                :loaded="item.loaded"
                :preferenceData="preferenceFood"
              />
              <RecentDiet
                v-show="index == 1"
                :data="recentDiet"
                :loaded="item.loaded"
              />
            </div>
          </van-tab>
        </van-tabs>
      </div>
      <!-- 点评内容 -->
      <div class="c-bottom">
        <AiNavComponent v-model="curActive" :data="dietData.ai_data" />
        <div v-show="curActive == 0">
          <div v-if="dietData && dietData.p_cid">
            <StepThree
              v-if="!dietData.extra_meal_card_comment"
              :autoShow="true"
              :data="reviewResult"
              :labelData="reviewResult.labelData"
            ></StepThree>
            <div
              v-if="dietData.extra_meal_card_comment && dietData.p_show == 1"
            >
              <div class="review-bottom">
                <div class="coach-info">
                  <img class="avatar" :src="dietData.p_img" />
                  <span class="coach-name">{{ dietData.p_name || '' }}</span>
                  <div class="flag-content">
                    <img
                      class="coach-flag"
                      src="https://cdnvue.gymcity.com.cn/uploads/f64ba6b28c32b85773836483c5333068.png"
                    />
                  </div>
                </div>
                <div class="info">
                  <span>{{ dietData.extra_meal_card_comment || '' }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="empty-comment" v-else>暂无点评</div>
          <div class="commont-time" v-if="dietData.p_show == 1">
            <span>点评时间：</span><span>{{ dietData.p_time }}</span>
          </div>
        </div>
        <AiComment v-show="curActive == 1" :data="dietData.ai_data" />
      </div>
      <div v-if="showStep">
        <div class="review-btn" v-if="!dietData.p_show" @click="bindReview">
          <span>{{ (data.active + 1) | filterActive }}</span
          ><span class="num">({{ data.active + 1 }}/3)</span>
        </div>
        <div class="review-btn" v-else @click="bindDelete"> 删除点评 </div>
        <van-overlay
          class="review-overlay"
          :show="showPopUp"
          @click="showPopUp = false"
          :lock-scroll="false"
          :z-index="2000"
        >
          <ReviewStep
            v-if="dietData && data.labelData.length"
            ref="reviewstep"
            v-model="showPopUp"
            :dietData="dietData"
            :data="data"
            @save="bindSave"
            @release="bindRelease"
            @change="bindStepChange"
          ></ReviewStep>
        </van-overlay>
      </div>
      <div v-else class="extra-container">
        <div class="extra-btn" v-if="!dietData.p_show" @click="bindReview"
          >点评</div
        >
        <div class="extra-btn" v-else @click="bindDelete">删除点评</div>
        <van-overlay
          class="review-overlay"
          :show="showPopUp"
          @click="showPopUp = false"
          :lock-scroll="false"
          :z-index="2000"
        >
          <ExtraComponent
            v-if="dietData"
            v-model="showPopUp"
            :dietData="dietData"
            :data="data"
            @save="bindSave"
            @release="bindRelease"
          ></ExtraComponent>
        </van-overlay>
      </div>
    </div>
  </div>
</template>
<script>
import AppNavbar from '@/components/app/nav-bar/index.vue'
import TagList from './components/tag-list.vue'
import AssociationFood from './components/association-food.vue'
import RecentDiet from './components/recent-diet.vue'
import ReviewStep from './components/review-step.vue'
import StepThree from './components/step-three.vue'
import AiNavComponent from '../nutritionist-reviews-tool-not-class/components/ai-nav.vue'
import AiComment from '../nutritionist-reviews-tool-not-class/components/ai-comment.vue'
import { scoreData } from './components/step-one/data'
import { ImagePreview } from 'vant'
import { reviewData, observeReviewData, deepClone, dietData } from './data'
import MyFixedInput from './components/my-fixed-input.vue'
import ExtraComponent from './components/extra.vue'
export default {
  name: 'nutritionist-tool-review-detail',
  components: {
    AppNavbar,
    TagList,
    AssociationFood,
    RecentDiet,
    ReviewStep,
    StepThree,
    MyFixedInput,
    ExtraComponent,
    AiNavComponent,
    AiComment
  },
  data() {
    return {
      curActive: 0,
      showFixedInput: false,
      coachId: '', //教练信息
      isWx: false,
      pid: '',
      options: {
        title: '餐卡点评'
      },
      id: '',
      tabType: '',
      curNav: 0,
      showPopUp: false,
      dietData: null,
      openTag: false, //是否打开标签
      sevenTagData: {
        //七日用户标签
        openTag: false,
        list: []
      },
      userTagData: {
        openTag: false,
        list: []
      }, //用户标签数据
      recentDiet: [], //最近饮食
      preferenceFood: [], //偏好食物
      associationData: null,
      AiCommentData: null, //ai点评数据
      /*  */
      data: {
        active: -1,
        openAiComment: true,
        labelData: [], //标签数据
        scoreData: [], //点评分数数据
        //点评内容
        reviewData: [],
        dietaryAdvice: {
          name: '未来饮食建议',
          val: 'future_dietary_analysis',
          value: '',
          minlength: 20,
          maxlength: 1000,
          require: true
        },
        exceptionDesc: {
          name: '异常描述',
          val: 'anomaly_records',
          value: '',
          maxlength: 1000
        }
      },
      //点评的结果
      reviewResult: {
        labelData: [], //标签数据
        scoreData: [], //点评分数数据
        //点评内容
        reviewData: [],
        dietaryAdvice: {
          name: '未来饮食建议',
          val: 'future_dietary_analysis',
          value: '',
          minlength: 20,
          maxlength: 1000,
          require: true
        },
        exceptionDesc: {
          name: '异常描述',
          val: 'anomaly_records',
          value: '',
          maxlength: 1000
        }
      },
      /*  */
      navList: [
        {
          name: '关联食材',
          functionName: 'getAssociationFood',
          loaded: false,
          show: false,
          list: []
        },
        {
          name: '最近饮食',
          functionName: 'getRecentDiet',
          loaded: false,
          show: false,
          list: []
        }
      ],
      isViewOriginal: false, //是否查看原图
      bbcData: null
    }
  },
  filters: {
    filterTime(str) {
      return str.replace(/-/g, '.')
    },
    filterActive(index) {
      return index == 0 ? '餐卡点评' : '继续点评'
    }
  },
  computed: {
    showStep() {
      return [0, 1, 2].includes(+this.$route.query.curMeal)
    },
    enumList() {
      return (this.dietData && this.dietData.enum_list) || []
    },
    bbcList() {
      if (this.bbcData) {
        let list = []
        for (let i = 0; i < 3; i++) {
          let item = this.bbcData.newest_baobao_meals[i]
          if (item) {
            let arr = item.check_date.split('-')
            let month = parseInt(arr[1])
            let day = parseInt(arr[2])
            list.push(
              `${month}月${day}日  ${item.meal_type_desc}  ${item.name}`
            )
          } else {
            list.push(`无`)
          }
        }
        return list
      } else {
        return []
      }
    }
  },
  watch: {},
  created() {
    this.isWx = window.__wxjs_environment
    this.coachId = localStorage.getItem('coachId')
    this.getQuery()
    this.cacheStorage = JSON.parse(this.getCoachReview(this.id))
    this.getLabelData()
    this.getAssociationFood()
    this.getDetail()
  },
  mounted() {},
  methods: {
    getFullMealData() {
      let params = {
        unify_id: this.dietData.unify_id,
        class_id: this.pid
      }
      this.$http
        .postApp('member/CampUgc/getCampMealDetailExtra', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.bbcData = res.data
          } else {
            this.$toast(res.msg)
          }
        })
        .catch(() => {})
    },
    //获取用户标签
    getUserTag() {
      let params = {
        uid: this.dietData.unify_id,
        headerObj: {
          clientversion: '88'
        }
      }
      this.$http
        .postBaseApp('member/UserTag/getUserTag', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.userTagData.list = res.data || []
          } else {
            this.$toast('获取用户标签失败')
          }
        })
        .catch(() => {})
    },
    //实时保存
    saveCoachReview(id, data) {
      localStorage.setItem('saveReviewById_' + id, JSON.stringify(data))
    },
    getCoachReview(id) {
      return localStorage.getItem('saveReviewById_' + id)
    },
    //删除保存的草稿
    removeCoachReview(id) {
      localStorage.removeItem('saveReviewById_' + id)
    },

    //监听data
    watchCacheData() {
      this.$watch(
        'data',
        () => {
          console.log('更新了')
          this.saveCoachReview(this.id, this.data)
        },
        {
          deep: true
        }
      )
    },
    //进入用户信息界面
    bindIntoUserInfo() {
      if (this.$http._isApp()) {
      } else {
        //前往小程序个人主页
        wx.miniProgram.navigateTo({
          url:
            '/package-ugc/pages/circleUserInfo/circleUserInfo' +
            '?unify_id=' +
            this.dietData.unify_id +
            '&pid=' +
            this.pid
        })
      }
    },
    bindCalebdar() {
      this.$router.push({
        path: '/nutritionist-tool/diet-calendar',
        query: {
          unifyId: this.dietData.unify_id,
          pid: this.pid,
          id: this.id,
          tabType: this.tabType
        }
      })
    },
    bindStepChange(active) {
      console.log(active, this.data.active)
      if (active > this.data.active) {
        this.data.active = active
      }
    },
    bindOpenTag(data) {
      data.openTag = !data.openTag
    },
    formatImageUrl(imageUrl) {
      if (imageUrl.indexOf('_heic_')) {
        imageUrl = imageUrl + '/format,png'
      }
      return imageUrl
    },
    getQuery() {
      let id = this.$route.query.id
      let pid = this.$route.query.pid
      let tabType = this.$route.query.tabType
      if (id) {
        this.id = id
      }
      if (pid) {
        this.pid = pid
      }
      if (tabType) {
        this.tabType = tabType
      }
    },
    bindChangeTitle(index, title) {
      if (!this.navList[index].loaded) {
        this[this.navList[index].functionName]()
      }
    },
    bindReview() {
      if (this.data.active == -1) {
        this.data.active = 0
      }
      this.showPopUp = true
    },
    getLabelData() {
      this.$http
        .postApp('member/NutritionistComments/labelData', {})
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            if (!this.data.labelData.length) {
              this.data.labelData = this.dealTagData(res.data)
            }
            this.reviewResult.labelData = this.dealTagData(res.data)
            if (this.dietData && this.dietData.p_label) {
              this.initTagData(this.dietData, this.data.labelData)
              this.initTagData(this.dietData, this.reviewResult.labelData)
            }
          }
        })
    },
    //处理获取到的标签
    dealTagData(data) {
      let cloneData = deepClone(data)
      cloneData.map((item) => {
        item.list.map((item1) => {
          item1.checked = false
        })
      })
      return cloneData
    },
    //获取餐卡的点评内容
    getDietCommentData() {
      let params = {
        gid: this.id
      }
      this.$http
        .getApp('member/CampUgc/getCampMealCardAnalysis', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            let data = res.data
            if (!data) {
              return
            }
            if (!this.cacheStorage) {
              this.initCommentData(data, this.data)
            }
            this.initCommentData(data, this.reviewResult)
          } else {
            this.$toast(res.msg)
          }
        })
        .catch((e) => {
          console.log(e)
        })
        .finally(() => {
          this.watchCacheData()
        })
    },
    initCommentData(data, resultData) {
      //主食等点评内容
      resultData.reviewData.map((item) => {
        if (data[item.val]) {
          item.value = data[item.val]
        }
      })
      //未来建议
      if (data[resultData.dietaryAdvice.val]) {
        resultData.dietaryAdvice.value = data[resultData.dietaryAdvice.val]
      }
      //异常描述
      if (resultData.exceptionDesc && data[resultData.exceptionDesc.val]) {
        resultData.exceptionDesc.value = data[resultData.exceptionDesc.val]
      }
    },
    getDetail() {
      let params = {
        gid: this.id,
        tab_type: this.tabType
      }
      this.$http
        .getApp('member/CampUgc/getCampUgcDetailToDietitian', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            let data = this.dealData(res.data)
            this.dietData = data
            this.getFullMealData()
            this.getUserTag()
            this.getWeekDietTag()
            this.getPreferenceFood()
            this.reviewResult.scoreData = this.initScoreData(
              data,
              this.reviewResult.scoreData
            )
            this.initTagData(data, this.reviewResult.labelData)
            this.initReviewData(data, this.reviewResult)
            //如果本地有草稿则获取并显示
            if (this.cacheStorage) {
              if (this.cacheStorage.labelData.length) {
                this.data = this.cacheStorage
              } else {
                //处理异常情况，如果缓存中的标签不存在，说明上次进入点评时因为接口问题未获取到标签列表，所以缓存不覆盖原来的数据
                let labelData = this.data.labelData
                this.data = this.cacheStorage
                this.data.labelData = labelData
              }
            } else {
              this.data.scoreData = this.initScoreData(data) //根据后台数据初始化分数
              this.initTagData(data, this.data.labelData)
              this.initReviewData(data, this.data)
              /* 加餐不限制评论字数 */
              if (data.p_type == 3 && this.$route.query.curMeal == 3) {
                this.data.reviewData.map((item) => {
                  item.minlength = undefined
                })
                this.data.dietaryAdvice.minlength = undefined
              }
            }
            this.getDietCommentData()
            this.$nextTick(() => {
              if (this.dietData.p_cid) {
                this.data.active = 2
              }
            })
          } else {
            this.$toast(res.msg)
          }
        })
        .catch((e) => {
          console.log(e)
        })
    },
    //根据后台数据初始化分数
    initScoreData(data) {
      let resultData = deepClone(scoreData)
      resultData.map((item) => {
        item.list.map((item1) => {
          if (data[item1.val] !== null && data[item1.val] !== '') {
            item1.index = data[item1.val] - 1
          }
        })
      })
      this.computedScore(resultData)
      return resultData
    },
    //计算分数 以及初始化禁用状态
    computedScore(data) {
      data.map((item, index) => {
        let score = item.maxScore
        let indexList = [] //存放要禁用的index;
        item.list.map((item1, index1) => {
          if (item1.index >= 0) {
            score += item1.select[item1.index].less
          }
          /* 判断是否禁用其他选项 */
          item1.select.map((seitem, seindex) => {
            if (seitem.disabledOther && item1.index == seindex) {
              indexList.push(index1)
            }
          })
        })
        if (indexList.length) {
          item.list.map((item1, index1) => {
            if (!indexList.includes(index1)) {
              item1.disabled = true
            }
          })
        }
        item.score = score
      })
      return data
    },
    //根据后端数据初始化标签选中状态
    initTagData(data, resultData) {
      if (!data || !resultData.length) {
        return
      }
      let obj = {}
      data.p_label.map((item) => {
        obj[item.id] = true
      })
      resultData.map((item, index) => {
        item.list.map((item1) => {
          if (obj[item1.id]) {
            item1.checked = true
          }
        })
      })
    },
    //根据餐卡类型决定哪些需要显示
    initReviewData(data, resultData) {
      //观察期打卡
      if (data.p_type == 7) {
        resultData.exceptionDesc = null
        resultData.reviewData = deepClone(observeReviewData)
      } else {
        resultData.reviewData = deepClone(reviewData)
      }
    },
    dealData(data) {
      data.say = (data.say || '').replace(/%/g, '%25')
      data.p_content = (data.p_content || '').replace(/%/g, '%25')
      data.say = decodeURIComponent(data.say)
      data.p_content = decodeURIComponent(data.p_content)
      return data
    },
    //预览图片
    previewImage(item, index) {
      ImagePreview({
        images: item,
        startPosition: index
      })
    },
    //删除点评
    bindDelete() {
      this.$dialog
        .confirm({
          title: '提示',
          message: '是否要删除点评?'
        })
        .then(() => {
          this.deleteReview()
        })
        .catch(() => {
          // on cancel
        })
    },
    //删除点评接口
    deleteReview() {
      let params = {
        cid: this.coachId,
        gid: this.id,
        pid: this.pid
      }
      this.$http
        .postApp('member/NutritionistComments/delCoachComment', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.$toast('删除成功')
            this.dietData.p_show = 0
          } else {
            this.$toast(res.msg)
          }
        })
        .catch(() => {})
    },
    //保存点评
    bindSave() {
      this.bindSubmit(0)
    },
    //发布点评
    bindRelease() {
      this.bindSubmit(1)
    },
    bindSubmit(pshow) {
      let params = {
        cid: this.coachId,
        id: this.dietData.id,
        curMeal: this.$route.query.curMeal,
        p_type: this.dietData.p_type,
        merit: this.getSelectTag('优点'), //优点
        defect: this.getSelectTag('缺点'), //缺点
        trait: this.getSelectTag('特点'), //特点
        special_nutrients: this.getSelectTag(
          '特殊营养素(仅作记录，不会展示在会员端)'
        ), //特点
        p_show: pshow
      }
      if (this.$route.query.curMeal == 3) {
        params.extra_meal_card_comment = this.dietData.extra_meal_card_comment
      }
      params = Object.assign(params, this.getSubmitParams())
      this.$http
        .postApp('member/NutritionistComments/saveCoachCommentDiet', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.removeCoachReview(this.id)
            this.$toast(pshow ? '发布成功' : '保存成功')
            if (pshow) {
              this.finishedComment(this.id)
            }
            this.$router.go(-1)
          } else {
            this.$toast(res.msg)
          }
        })
    },
    //完成评论
    finishedComment(id) {
      localStorage.setItem('finishedCommentId', id)
    },
    //获取提交参数
    getSubmitParams() {
      let params = {}
      //评分
      this.data.scoreData.map((item) => {
        item.list.map((item1) => {
          params[item1.val] = item1.index + 1
        })
      })
      //点评内容
      this.data.reviewData.map((item) => {
        params[item.val] = item.value
      })
      //未来建议
      params[this.data.dietaryAdvice.val] = this.data.dietaryAdvice.value
      //异常描述
      if (this.data.exceptionDesc) {
        params[this.data.exceptionDesc.val] = this.data.exceptionDesc.value
      }
      return params
    },
    //获取选中的标签
    getSelectTag(str) {
      let res = []
      this.data.labelData.map((item) => {
        if (item.name == str) {
          item.list.map((item1) => {
            if (item1.checked) {
              res.push(item1.id)
            }
          })
        }
      })
      return res.join(',')
    },
    //获取关联食物
    getAssociationFood() {
      let index = this.curNav
      let params = {
        gid: this.id
      }
      this.$http
        .getApp('member/NutritionistComments/getMealCardAssociatedFood', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.associationData = res.data
          }
          this.navList[index].loaded = true
        })
    },
    //获取最近饮食
    getRecentDiet() {
      let index = this.curNav
      let params = {
        pid: this.pid,
        unify_id: this.dietData.unify_id,
        day: 3
      }
      this.$http
        .getApp('member/NutritionistComments/getUserMealCardRecord', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.recentDiet = res.data
          }
          this.navList[index].loaded = true
        })
    },
    getWeekDietTag() {
      let params = {
        unify_id: this.dietData.unify_id
      }
      this.$http
        .postApp(
          'member/NutritionistComments/getUserLatelySevenDaysLab',
          params
        )
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.sevenTagData.list = this.sortTag(res.data.content)
          }
        })
    },
    //获取偏好食物
    getPreferenceFood() {
      let params = {
        unify_id: this.dietData.unify_id
      }
      this.$http
        .postApp(
          'member/NutritionistComments/getPreferenceFoodListByRank',
          params
        )
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.preferenceFood = res.data
          }
        })
    },
    //标签排序
    sortTag(list) {
      list.sort((a, b) => {
        {
          if (a.label_weight != b.label_weight) {
            //优先标签权重，权重不一致则权重高的排在前面
            return b.label_weight - a.label_weight
          } else {
            //权重一致则次数高的排在前面
            return b.label_num - a.label_num
          }
        }
      })
      return list
    },
    //获取开启结束等点评内容默认文案
    getReviewData(type, val) {
      if (this.reviewLoaded || this.dietData.p_cid || this.cacheStorage) {
        return
      }
      let params = {
        addtime: this.dietData.addtime,
        pid: this.$route.query.pid,
        p_type: this.dietData.p_type,
        curMeal: this.$route.query.curMeal,
        unify_id: this.dietData.unify_id,
        postion_type: type
      }
      this.$http
        .getApp('member/NutritionistComments/getAllCommentRecommend', params)
        .then((res) => {
          res = res.data
          if (res.code == 200 && res.data) {
            this.data.reviewData.map((item) => {
              if (item.val == val) {
                item.value = res.data
              }
            })
            //饮食建议
            if (this.data.dietaryAdvice.val == val) {
              this.data.dietaryAdvice.value = res.data
            }
          }
          this.reviewLoaded = true
        })
    }
  }
}
</script>
<style lang="scss">
.page-content {
  .van-tab {
    flex: 0 0 auto;
    padding: 0px 12px;
  }

  .van-tabs__line {
    width: 16px;
    height: 4px;
    background: #6236ff;
    border-radius: 2px;
  }

  .van-tab--active {
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.8);
    line-height: 20px;
  }
}
</style>
<style lang="scss" scoped>
.page-content {
  background: #fff;
  min-height: 100vh;
}

.container {
  padding-bottom: 100px;

  .c-top {
    background-color: #fff;
    padding-bottom: 19px;

    .c-padding {
      padding: 0px 20px;
      box-sizing: border-box;
    }

    .user-info {
      display: flex;
      align-content: center;
      margin-bottom: 8px;

      .avatar {
        width: 36px;
        height: 36px;
        border-radius: 6px;
        overflow: hidden;
        margin-right: 10px;
      }

      .user-right {
        flex: 1;
        flex-shrink: 0;
        overflow: hidden;

        .name {
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          font-size: 12px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: rgba(0, 0, 0, 0.8);
          line-height: 17px;
        }

        .camp {
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          font-size: 10px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.6);
          line-height: 14px;

          .nickname {
            margin-right: 10px;
          }
        }
      }

      .user-calendar {
        padding: 10px;
      }
    }

    .tag-container {
      position: relative;
      margin-bottom: 14px;
      padding-bottom: 20px;

      .tag-list {
        display: flex;
        align-items: center;
        flex-wrap: wrap;

        .tag-item {
          height: 24px;
          line-height: 24px;
          background: #f9f9f9;
          border-radius: 4px;
          padding: 0px 8px;
          margin-right: 8px;
          margin-bottom: 8px;
          font-size: 12px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;

          .tag-color-1 {
            color: #2bb79b;
          }

          .tag-color-2 {
            color: #f04646;
          }

          .tag-num {
            margin-left: 6px;
            font-size: 10px;
            font-family: PingFangSC-Regular, PingFang SC;
            color: rgba(0, 0, 0, 0.5);
            line-height: 14px;
          }
        }

        .user-tag-1 {
          background: linear-gradient(#fffef8 0%, #eefff4 100%);
        }

        .user-tag-2 {
          background: linear-gradient(#f9d5ff 0%, #ffe0e0 100%);
        }

        .user-tag-3 {
          background: linear-gradient(#faf8ff 0%, #eefbff 100%);
        }
      }

      .open-tag {
        position: absolute;
        right: 20px;
        bottom: 0;
        color: rgba(0, 0, 0, 0.5);

        .iconfont {
          width: 20px;
          height: 20px;
          text-align: center;
          line-height: 20px;
          border-radius: 50%;
          background: #ffffff;
          border: 1px solid #f1f1f1;
          margin-left: 6px;
        }
      }
    }

    .maxheight {
      max-height: 28px;
      overflow: hidden;
    }

    .diet-image-container {
      width: 100%;
      overflow-y: scroll;
      margin-bottom: 16px;

      .d-list {
        display: inline-flex;
        align-items: center;
        padding: 0px 20px;

        .d-item {
          width: 150px;
          height: 150px;
          object-fit: cover;
          margin-right: 8px;
        }

        .d-item:last-child {
          margin-right: 0px;
        }
      }

      .is-view-original {
        margin-top: 10px;
        padding-right: 20px;
        display: flex;
        justify-content: end;
      }
    }

    .diet-info {
      .diet-title {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.8);
        line-height: 22px;
        margin-bottom: 7px;
      }

      .diet-desc {
        white-space: pre-wrap;
        word-break: break-all;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: rgba(0, 0, 0, 0.8);
        line-height: 24px;
        margin-bottom: 10px;
      }

      .ai-desc {
        margin-bottom: 10px;

        .ai-title {
          margin-bottom: 6px;
          font-weight: bold;
        }
      }

      .status-tag-list {
        display: flex;
        flex-wrap: wrap;

        .status-tag-item {
          max-width: 100%;
          text-overflow: ellipsis;
          line-height: 24px;
          overflow: hidden;
          white-space: nowrap;
          background-color: rgb(164, 173, 179);
          border-radius: 4px;
          padding: 0px 6px;
          font-size: 12px;
          color: #fff;
          margin-right: 6px;
          margin-bottom: 4px;
        }

        .status-tag-icon-item {
          padding: 1px;
          border-radius: 12px;
        }

        .status-tag-icon {
          height: 24px;
        }
      }

      .diet-time {
        font-size: 13px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: rgba(0, 0, 0, 0.3);
        line-height: 18px;
      }
    }

    .bbc-container {
      padding: 0px 20px;
      margin-top: 16px;

      .bbc-title {
        padding: 0px 10px;
        height: 30px;
        background: #f9f9f9;
        border-radius: 4px;
        font-family: PingFangSC, PingFang SC;
        font-weight: bold;
        font-size: 14px;
        display: flex;
        align-items: center;
        color: rgba(0, 0, 0, 0.8);
        margin-bottom: 6px;
      }
      .bbc-list {
        .bbc-item {
          font-size: 14px;
          color: rgba(0, 0, 0, 0.8);
          line-height: 24px;
        }
      }
    }
  }

  .space {
    height: 8px;
    background-color: #f9f9f9;
  }

  /*  */
  .c-center {
    background-color: #fff;
    padding: 20px 20px 0px;
    box-sizing: border-box;

    .tab-container {
      margin-top: 16px;
    }
  }
}

.review-btn {
  position: fixed;
  left: 50%;
  bottom: 20px;
  transform: translate(-50%, 0%);
  width: 335px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background: #6236ff;
  border-radius: 10px;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: #ffffff;
  line-height: 40px;

  .num {
    margin-left: 6px;
    font-size: 12px;
    color: rgba(194, 177, 255, 1);
  }
}

.overlay-content {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 2001;
}

.calendar {
  color: rgba(74, 61, 107, 1);
}

.review-overlay {
  background-color: rgba(0, 0, 0, 0.1);
}

.extra-container {
  .extra-btn {
    position: fixed;
    left: 50%;
    bottom: 20px;
    transform: translate(-50%, 0%);
    width: 335px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background: #6236ff;
    border-radius: 10px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: #ffffff;
  }
}

.empty-comment {
  padding: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.commont-time {
  padding: 0px 16px;
  color: rgba(0, 0, 0, 0.6);
}

.c-bottom {
  .review-bottom {
    padding: 9px 16px;
    border-radius: 0px 5px 5px 5px;

    .coach-info {
      display: flex;
      align-items: center;

      .avatar {
        flex: 0 0 22px;
        margin-right: 6px;
        width: 22px;
        height: 22px;
        border-radius: 5px;
      }

      .coach-name {
        font-size: 12px;
        color: #000000;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        margin-right: 8px;
      }

      .coach-flag {
        width: 68px;
      }
    }

    .info {
      margin-top: 5px;
      font-size: 12px;
      line-height: 22px;
      color: rgba(0, 0, 0, 0.6);
      word-break: break-all;
      word-wrap: break-word;
    }
  }
}
</style>
